import { useEffect, useState } from "react";
import { z } from "zod";
import { apiRequest } from "../../shared/api/client";

const weeksSchema = z.array(z.object({ weekStart: z.iso.date(), label: z.string(), active: z.boolean(), status: z.enum(["ACTIVE", "PREPARED", "ARCHIVED", "CARRYOVER", "CLOSED"]).optional() }));
export type PackagingWeek = z.infer<typeof weeksSchema>[number];
export function usePackagingWeeks() {
  const [weekStart, setWeekStart] = useState("");
  const [weeks, setWeeks] = useState<PackagingWeek[]>([]);
  const [weeksError, setWeeksError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    void apiRequest<unknown>("/api/sarf39/manual-packaging/weeks", { signal: controller.signal, cache: "no-store" })
      .then((data) => { if (!controller.signal.aborted) setWeeks(weeksSchema.parse(data)); })
      .catch((reason: unknown) => { if (!controller.signal.aborted) setWeeksError(reason instanceof Error ? reason.message : "Haftalar yüklenemedi."); });
    return () => controller.abort();
  }, []);
  return { weekStart, setWeekStart, weeks, weeksError };
}
